<template>
    <v-dialog v-model="dialogModel">
        <div class="elevation-5 card">
            <v-form :lazy-validation="true" ref="form" v-model="valid">
                <v-layout row wrap>
                    <v-flex xs12>
                        <h2>Linea de Documento</h2>
                    </v-flex>
                    <v-flex md3>
                        <v-text-field class="lance"
                            label="Código Producto"
                            v-model="form.productCode"
                        ></v-text-field>
                    </v-flex>
                    <v-flex md9>
                        <v-text-field class="lance"
                            label="Descripción"
                            v-model="form.description"
                        ></v-text-field>
                    </v-flex>
                    <v-flex md3>
                        <v-text-field class="lance"
                            label="Precio Unitario"
                            v-model="form.price"
                        ></v-text-field>
                    </v-flex>
                    <v-flex md3>
                        <v-text-field class="lance"
                            label="Cantidad"
                            v-model="form.quantity"
                        ></v-text-field>
                    </v-flex>
                    <v-flex md3>
                        <v-text-field class="lance"
                            label="Importe"
                            :value="formatCurrency(form.quantity * form.price)"
                            disabled
                        ></v-text-field>
                    </v-flex>
                    <v-flex md3>
                        <v-text-field class="lance"
                            label="Impuesto"
                            v-model="form.taxes"
                        ></v-text-field>
                    </v-flex>
                    <v-flex md3>
                        <v-text-field class="lance"
                            label="Retencion"
                            v-model="form.withheldTaxTotal"
                        ></v-text-field>
                    </v-flex>
                    <v-flex md3>
                        <v-text-field class="lance"
                            label="Total"
                            :value="formatCurrency(form.quantity * form.price + Number(form.taxes) - Number(form.withheldTaxTotal))"
                            disabled
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 style="display: flex;">
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" flat @click="cancel">Cancelar</v-btn>
                        <v-btn
                            solo
                            color="submitBtn"
                            @click="doAction"
                            :disabled="!valid"
                            style="color: white;"
                            >Agregar</v-btn>
                    </v-flex>
                </v-layout>
            </v-form>
        </div>
    </v-dialog>
</template>

<script>
export default {
    props: [
        "value",
        "editData"
    ],
    data() {
        return {
            action: null,
            valid: null,
            dialogModel: this.value,
            form: {
                productCode: '',
                description: '',
                price: 0,
                quantity: 0,
                subTotal: 0,
                withheldTaxTotal: 0,
                taxes: 0,
            },
        };
    },
    methods: {
        doAction() {
            if(this.$refs.form.validate()) {
                this.$refs.form.resetValidation();
                this.form.subTotal = this.form.quantity * this.form.price || 0;
                this.form.rateOrFee = this.form.taxes / (this.form.subtotal) || 0;
                this.form.withheldTaxRate = this.form.withheldTaxTotal / this.form.subTotal || 0;
                this.form.totalTaxes = this.taxes - this.withheldTaxTotal || 0;
                this.$emit(this.action, this.form);
            }
        },
        cancel() {
            this.$refs.form.resetValidation();
            this.$emit("cancel");
        },
        formatCurrency(num) {
            return "$ " + Number(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        },
    },
    mounted() {
        if (this.editData)  {
            this.action = "edit";
            Object.assign(this.form, this.editData);
        } else {
            this.action = "add";
        }
    },
    watch: {
        "dialogModel": function(newVal) { this.$emit("input", newVal); },
    }
}
</script>

<style scoped>
    .layout {
        margin: -8px !important;
    }
    .flex {
        padding: 8px !important;
    }
    .card {
        background-color: white;
        border-radius: 16px;
        margin-bottom: 28px;
        margin: 0;
        padding: 40px;
    }
</style>